import { TitleAndValue } from '../../../../../components/UI-Elements/TitlesAndTexts/TitleAndValueList';
import { FormatToShortPriceTemplate, formatToShortString } from '../../../../../utils/FormatValue';
import {
  getOpportunityTotalPrice,
  getOpportunityTotalQuantity,
  getPercentageChange,
  getTotalProfit,
  getTotalProfitByRoute,
} from '../../../opportunityDashboardUtils';
import { ITransactionOpportunity } from '@sp-types/transactionOpportunityType';
import React from 'react';

interface Props {
  data: ITransactionOpportunity[];
}

export const SummaryData: React.FC<Props> = ({ data }) => {
  return (
    <div className="flex flex-col flex-1 gap-3 overflow-hidden ">
      <p className="text-lg font-medium">Hedge performance summary</p>
      <div className="flex flex-col flex-1 gap-3 flex-wrap overflow-auto">
        <TitleAndValue
          textSize="md"
          titleValueData={[
            {
              title: 'Total hedged quantity',
              valueAsString: getOpportunityTotalQuantity(data).toLocaleString() + ' ton',
            },
            { title: 'Hedged $ value', valueAsString: FormatToShortPriceTemplate(getOpportunityTotalPrice(data)) },
            {
              title: 'Naked position P/L',
              valueAsString: FormatToShortPriceTemplate(getTotalProfit(data)),
            },
            {
              title: 'Hedge strategy P/L',
              valueAsString: `  ${FormatToShortPriceTemplate(getTotalProfitByRoute(data))} / `,
              AddedComponent: () => {
                const changeInPrec = getPercentageChange(getOpportunityTotalPrice(data), getTotalProfitByRoute(data));
                return (
                  <span
                    className={`col-span-1 truncate   content-center ${
                      changeInPrec > 0 ? 'text-green-flat' : 'text-orange-500'
                    } `}
                  >
                    (%{formatToShortString(changeInPrec, 0)})
                  </span>
                );
              },
            },
          ]}
        />
      </div>
    </div>
  );
};
